import type { ApacCandidateHeader } from '@seek/apac-candidate-header-footer';
import { useMelwaysLink } from '@seek/melways-react';
import { siteConfig } from '@seek/melways-sites';

import { useAppConfig } from 'src/components/App/useAppConfig';
import {
  RECOMMENDED_JOBS_ROUTE,
  RECOMMENDED_JOBS_ROUTE_NAME,
  SAVED_SEARCH_ROUTE,
} from 'src/constants';

type LanguageSwitcher = Parameters<
  typeof ApacCandidateHeader
>[0]['languageSwitcher'];

export const useLanguageSwitcher = (): LanguageSwitcher => {
  const { route, site } = useAppConfig();
  const { languages } = siteConfig[site];

  const currentPath =
    route === RECOMMENDED_JOBS_ROUTE_NAME
      ? RECOMMENDED_JOBS_ROUTE
      : SAVED_SEARCH_ROUTE;

  const localize = useMelwaysLink();

  if (languages.length <= 1) {
    return undefined;
  }

  return Array.from(languages).reduce<LanguageSwitcher>((switcher, lang) => {
    switcher![lang] = {
      url: localize({
        path: currentPath,
        language: lang,
      }),
    };
    return switcher;
  }, {});
};
